export function getPageTypeFromUrl(url = '') {
  let pageType = null;
  if (url.includes('/models/')) {
    const hasMlp = url.includes('/overview');
    const hasBuild = url.includes('/build');
    if (hasMlp && !hasBuild) {
      pageType = 'mlp';
    }
    if (hasMlp && hasBuild) {
      pageType = 'build';
    }
    return pageType;
  }
  return pageType;
}
